import { useNavigate } from 'react-router-dom';
import DataTableWrapper from '../../../Utility/DataTableWrapper/DataTableWrapper';
import { useContext, useEffect, useRef, useState } from 'react';
import { FaseService } from '../../../../services/FaseService';
import moment from 'moment';
import Modal from '../../../Utility/Modal/Modal';
import { FormUtility } from '../../../Utility/FormUtility';
import ToastContext from '../../../../contexts/toast';

export default function GestioneFasi() {
  console.log('inside gestione fasi');
  const [dtOptions, setDtOptions] = useState({});
  const navigate = useNavigate();

  const [fase, setFase] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const faseService = new FaseService();
  const utility = new FormUtility();

  const toastContext = useContext(ToastContext);

  const dtRef = useRef();

  const allTipologie = utility.getAllTipologie();

  useEffect(() => {
    console.log('cambiato dtoptions', dtOptions);
  }, [dtOptions]);

  const gotoGestioneFase = () => {
    navigate('/gestione-fase');
  };

  const gotoModificaFase = (faseId) => {
    navigate('/gestione-fase/' + faseId);
  };

  const handleModalAction = () => {
    faseService.delete(fase).then(() => {
      dtRef.current.rerenderDatatable();
      setModalOpen(false);
      toastContext.success('Fase eliminata con successo!', 6000);
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
		});
  };

  const eliminaFase = (fase) => {
    setModalOpen(true);
    setFase(fase.id);
  };

  useEffect(() => {
    const dtOpt = {
      columns: [
        {
          name: 'Id',
          data: 'id',
          visible: true,
          sortable: true,
          searchable: false,
        },
        {
          name: 'Avviso',
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          cell: (row, col) => {
            return (
              <div className='rtds-justify-between rtds-flex'>
                <span className='lg:rtds-hidden rtds-font-semibold'>
                  {col.name}
                </span>
                {row.bando.nome}
              </div>
            );
          },
        },
        {
          name: 'Titolo',
          data: 'titolo',
          visible: true,
          sortable: true,
          searchable: true,
        },
        {
          name: 'Tipologia',
          data: 'tipologia',
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) => {
            return (
              allTipologie.find(el => el.key === row[col.data])?.value
            );
          },
        },
        {
          name: 'Fase associata',
          data: 'raccoltaDomande',
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) => {
            return (
              <div className='rtds-justify-between rtds-flex'>
                <span className='lg:rtds-hidden rtds-font-semibold'>
                  {col.name}
                </span>
                {row[col.data]?.titolo}
              </div>
            );
          },
        },
        {
          name: 'Data Inizio',
          data: 'dataInizio',
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) => {
            return (
              <div className='rtds-justify-between rtds-flex'>
                <span className='lg:rtds-hidden rtds-font-semibold'>
                  {col.name}
                </span>
                {moment(row[col.data]).format('DD/MM/YYYY HH:mm')}
              </div>
            );
          },
        },
        {
          name: 'Data Fine',
          data: 'dataFine',
          visible: true,
          sortable: true,
          searchable: true,
          cell: (row, col) => {
            return (
              <div className='rtds-justify-between rtds-flex'>
                <span className='lg:rtds-hidden rtds-font-semibold'>
                  {col.name}
                </span>
                {moment(row[col.data]).format('DD/MM/YYYY HH:mm')}
              </div>
            );
          },
        },
        {
          name: 'Azioni',
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => (
            <div
              className='rtds-inline-flex rtds-gap-1'
              role='group'
              aria-label='Azioni'
            >
              <button
                type='button'
                className='rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => gotoModificaFase(row.id)}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`}
                  />
                </svg>
                Modifica
              </button>{' '}
              <button
                type='button'
                className='rtds-btn--danger rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => eliminaFase(row)}
                disabled={row.fasiAssociate.length > 0}
                title={row.fasiAssociate.length > 0 ? 'Fase non eliminabile essendo associata ad un\'altra' : 'Elimina fase'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--trash`}
                  />
                </svg>
                Elimina
              </button>
            </div>
          ),
        }
      ],
      serverSide: true,
      ajax: faseService.getAllDt,
      rows: [
        /*{ id: 1, title: 'test 123', year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative avviso del 23/24' }*/
      ],
      sorts: [],
      hideSearch: false,
      title: 'Elenco Fasi'
    };
    setDtOptions(dtOpt);
    loadData();
  }, []);

  const loadData = async () => {
    // let rows= [];
    // for (let i = 1;i<400;i++){
    //     rows.push({ id: i, title: 'test ' + i, year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative avviso del 23/24' });
    // }
    // setDtOptions((dtOptions)=> ({...dtOptions,rows}));
  };

  return (
    <>
      <div className="rtds-container rtds-py-6">
        <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
          <div className="rtds-flex rtds-items-center rtds-justify-between">
            <h1 className="rtds-heading-2">Gestione Fasi</h1>
          </div>
        </div>
      </div>

      <DataTableWrapper
        ref={dtRef}
        dtOptions={dtOptions}
        headerButton={
          <button
            type="button"
            className="rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
            onClick={gotoGestioneFase}
          >
            <svg
              className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use
                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
              />
            </svg>{" "}
            Inserisci&nbsp;nuova&nbsp;Fase
          </button>
        }
      />

      <Modal
        isOpen={isModalOpen}
        title="Elimina Fase"
        content="Sei sicuro di voler eliminare questa fase? Una volta rimossa, non potrai recuperarla."
        onClose={() => setModalOpen(false)}
        onAction={handleModalAction}
        actionLabel="Conferma"
        closeLabel="Annulla"
      />
    </>
  );
}
